<template>
  <SoDialog
    v-model="value"
    :loading="false"
    width="1200"
    card-title="Partner payment plans"
    data-testid="partner-plans-modal-dialog"
    @on-close="$emit('closeModal')"
  >
    <p>What we <b>can</b> do:</p>

    <div class="mt-4">
      <ul class="ml-8">
        <li>Change the Direct Debit amount</li>
        <li>Change the Direct Debit date</li>
      </ul>
    </div>

    <p class="mt-4">What we <b>can’t</b> do:</p>

    <div class="mt-4">
      <ul class="ml-8">
        <li>Cancel the payment plan</li>
        <li>Make any changes to the plan</li>
      </ul>
    </div>

    <p class="mt-4">
      Raise a task to collections if changes are needed to the plan.
    </p>

    <div class="d-flex justify-end mt-8">
      <SoButton
        data-testid="partner-plans-modal-close-btn"
        type="secondary"
        title="Close"
        class="mr-2"
        large
        @click="$emit('closeModal')"
      />
    </div>
  </SoDialog>
</template>
<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoButton,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue", "closeModal"],
    data() {
      return {
        showModal: true,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>
